// storage.ts
import { get, set, del } from "idb-keyval";

export async function saveItem(key: string, value: any) {
    await set(key, value);
}

export async function loadItem(key: string) {
    return await get(key);
}

export async function removeItem(key: string) {
    await del(key);
}
